import axios from 'axios';
import properties from '../../properties';
import { UserQuickLinkOverride } from '../../../_components/molecules/HomeQuickLinks';

export const getTypesAndFeatures = async () => {
  return await axios.get(
    properties.aiqBaseUrl + properties.features + properties.getAllFeatures,
  );
};
export const getEmployerGroups = async (token: string) => {
  return await axios.post(properties.aiqBaseUrl + properties.dateFiltersURL, {
    headers: {
      Authorization: token,
    },
  });
};
export const getNotifications = async (
  token: string,
  params?: {
    limit?: number;
    cursor?: any;
  },
) => {
  return axios.get(
    properties.aiqBaseUrl +
      properties.dateFiltersURL +
      properties.getNotifications,
    {
      headers: {
        Authorization: token,
      },
      params: {
        limit: params?.limit ?? 20,
        cursor: params?.cursor ? JSON.stringify(params.cursor) : undefined,
      },
    },
  );
};
export const getComplianceAssuranceGroups = async () => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.contractBaseUrl +
      properties.getAllGroups,
    {
      usePagination: false,
    },
  );
};
export const getScreenData = async () => {
  return await axios.get(properties.userManagementBaseUrl + properties.screen);
};

export const getQuickLinks = async (userId: string) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.dateFiltersURL +
      properties.getQuickLinks,
    { userId },
  );
};

export const updateQuickLinks = async (
  userId: string,
  overrides: UserQuickLinkOverride[],
) => {
  return await axios.post(
    properties.aiqBaseUrl +
      properties.dateFiltersURL +
      properties.updateQuickLinks,
    { userId, overrides },
  );
};

export const getCohortDetailsDrillDowns = async () => {
  return await axios.get(
    properties.aiqBaseUrl + properties.summaryBaseUrl + properties.drillDown,
  );
};
